export const report = {
    data(){

    },
    computed: {
        VOCTagsList: {
            get() {
                return this.$store.state.VOCTagsList
            },
            set(val) {
                this.$store.commit("updateVOCTagsList", val);
            }
        },
    },
    methods:{
        handleVOCTagsList(item) {
            let List = JSON.parse(JSON.stringify(this.VOCTagsList))

            let isExist = false
            for (let i = 0; i < List.length; i++) {
                if (List[i].routerName === item.routerName && List[i].query === item.query) {
                    isExist = true
                }
            }

            if (!isExist) {
                List.push(item)
                this.VOCTagsList = List
            }
        },
    }
}